import type { HTMLAttributes, Ref } from "react";

import { cn } from "../../lib/utils";
import { useCardContext } from "./CardContext";
import { cardRegionVariants } from "./styles";

export interface CardSectionProps extends HTMLAttributes<HTMLDivElement> {
  ref?: Ref<HTMLDivElement>;
}

/** A region of `Card.Body`. Stack as many as needed. */
export const CardSection = ({ className, ref, ...props }: CardSectionProps) => {
  const { variant, padding } = useCardContext();

  return (
    <div
      ref={ref}
      data-slot="card-section"
      className={cn(cardRegionVariants({ variant, padding }), className)}
      {...props}
    />
  );
};
